export default "__VITE_ASSET__CyjxXool__"